export default __webpack_public_path__ + "fe32d63.png";